import {
  Component,
  OnInit,
  Compiler,
  ComponentFactoryResolver,
} from '@angular/core';
import { Chart } from 'chart.js';
import { CommonService } from '../service/commons-service';
import { first, retry } from 'rxjs/operators';
import { Common } from '../util/common';
import { AppConfig } from '../util';
import { NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { HeaderCustomComponent } from '../header/headerCustom.component';
import { ExcelService } from '../service/excel.service';

const equals = (one: NgbDateStruct, two: NgbDateStruct) =>
  one &&
  two &&
  two.year === one.year &&
  two.month === one.month &&
  two.day === one.day;

const before = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day < two.day
      : one.month < two.month
    : one.year < two.year;

const after = (one: NgbDateStruct, two: NgbDateStruct) =>
  !one || !two
    ? false
    : one.year === two.year
    ? one.month === two.month
      ? one.day === two.day
        ? false
        : one.day > two.day
      : one.month > two.month
    : one.year > two.year;

@Component({
  selector: 'app-user-dashboard',
  templateUrl: './user-dashboard.component.html',
  styleUrls: ['./user-dashboard.component.css'],
})
export class UserDashboardComponent implements OnInit {
  users: any = {};
  chart: any;
  userList: any[] = [];
  loading = false;
  showDashboardSections: boolean = false;
  loginImageURL: any = null;

  // private hideDashboard: boolean = false;

  userFunSkillList: any[] = [];
  userFunSkillRatingList: any[] = [];
  userSkillRatingData: any[] = [];

  userBehSkillRatingList: any[] = [];
  userBehSkillList: any[] = [];
  selectedUserId: any = 'Select User';
  selectedUserPosition: any;
  selectedUserName: any;
  compositePercentAverage: any = { full: 0 };

  positionList: any = [];
  selectedPositionId: Number = 0;
  selectedCombinedId: any;

  // private userFunSkillList: any[] = [];
  // private userFunSkillRatingList: any[] = [];
  // private userSkillRatingData: any[] = [];
  functionalActive = '';
  behavioralActive = '';

  hoveredDate: NgbDateStruct;
  fromDate: NgbDateStruct;
  toDate: NgbDateStruct;

  canvasContainerHeight;
  // private skillList: any[] = [];
  behSkillList: any[] = [];
  userStrengths: any[] = [];
  userOppurtunities: any[] = [];
  loginUserName: any = '';
  userWeaknesses: any[] = [];
  userThreats: any[] = [];
  activeTab = 'beh';
  userRoll: number = 0;
  nextPosition: any = '';
  nextPositionId: any = '';
  alreadyHalved: boolean = false;
  constructor(
    private commonService: CommonService,
    private excelService: ExcelService,
    private router: Router,
    private appConfig: AppConfig,
    private common: Common,
    private _compiler: Compiler
  ) {
    this._compiler.clearCache();
    this.users = JSON.parse(localStorage.getItem('user'));
    if (!this.users || !this.users.userData) {
      this.commonService.logout();
      return;
    }
    if (this.users && this.users.userData) {
      if (this.users.userData.userFullName) {
        this.loginUserName = this.users.userData.userFullName;
      } else {
        this.loginUserName = this.users.userData.userName;
      }
      this.userRoll = this.users.userData.userRoll;
    }
    this.loginImageURL = this.appConfig.getDefaultImgURL();
  }

  ngOnInit() {
    // this.getSkillDetails();
    // this.getAllBehSkills();

    this.getUsersList();
    // this.getSkillRatingDetails();
    this.fetchPositions();
  }

  private generateFourBlocksData(skillType) {
    var skillList;

    if (skillType === 'beh') {
      skillList = this.userBehSkillRatingList;
    } else if (skillType === 'fun') {
      skillList = this.userFunSkillRatingList;
    }

    this.userStrengths = [];
    this.userOppurtunities = [];
    this.userWeaknesses = [];
    this.userThreats = [];

    for (var i = 0; i < skillList.length; i++) {
      if (skillList[i].ratedByRole !== 4) continue;

      var percentage =
        (skillList[i].skillScore * 100) / skillList[i].targetScore;
      if (percentage >= 80) {
        this.userStrengths.push(skillList[i].skillName);
      } else if (percentage >= 60 && percentage < 80) {
        this.userOppurtunities.push(skillList[i].skillName);
      } else if (percentage >= 40 && percentage < 60) {
        this.userWeaknesses.push(skillList[i].skillName);
      } else {
        this.userThreats.push(skillList[i].skillName);
      }
    }
  }

  //generate total utilized chart
  private generateSkillDevelopmentChart(skillType) {
    debugger;
    // let dataPoints_1 = [100, 200, 120, 1000, 230, 2000, 1100, 100];
    // let dataPoints_2 = [333, 777, 111, 1000, 655, 200, 600, 321];
    // let labels = [];

    var skillList;
    if (skillType === 'beh') skillList = this.userBehSkillRatingList;
    else {
      skillList = this.userFunSkillRatingList;
      // if(!this.alreadyHalved) {
      //   var half_length = Math.ceil(skillList.length / 2);
      //   skillList = skillList.splice(0,half_length);
      // }
      this.alreadyHalved = true;
    }
    var ratings = [],
      labels = [],
      gaps = [],
      fullLabels = [];
    for (var i = 0; i < skillList.length; i++) {
      if (skillList[i].ratedByRole !== 4) continue;

      ratings.push(skillList[i].skillScore);

      var skillName = skillList[i].skillName;
      if (skillName.length > 30) {
        skillName = skillName.substring(0, 30) + '...';
      }

      labels.push(skillName);
      fullLabels.push(skillList[i].skillName);
      var gap = skillList[i].targetScore - skillList[i].skillScore;
      gaps.push(gap > 0 ? gap : 0);
    }

    // labels = this.common.breakAllSentencesInLines(labels, 40)

    if (this.chart) {
      this.chart.destroy();
    }

    this.canvasContainerHeight = labels.length * 20 + 250 + 'px';
    //(labels.length > 5 ?(labels.length * 20) + 250 : '') + "px";

    this.chart = new Chart('skill_development_chart', {
      type: 'horizontalBar',
      // height: 1000,
      // width: '100%',
      data: {
        labels: labels,
        textColor: '#000000',
        datasets: [
          {
            label: 'Current',
            data: ratings,
            backgroundColor: '#28a745', // green
          },
          {
            label: 'Gap',
            data: gaps,
            backgroundColor: '#d87107', // white
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,

        legend: {
          labels: {
            // This more specific font property overrides the global property
            fontColor: 'black',
          },
        },

        tooltips: {
          callbacks: {
            title: function (tooltipItem, data) {
              return fullLabels[tooltipItem[0].index];
            },
            label: function (tooltipItem, data) {
              var label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }
              // if(data.datasets[tooltipItem.datasetIndex].label === "Target") {
              //   label += (tooltipItem.xLabel + ratings[tooltipItem.index]);
              // }
              // else {
              label += tooltipItem.xLabel;
              // }
              return label;
            },
          },
        },

        scales: {
          xAxes: [
            {
              stacked: true,

              ticks: {
                max: 5,
                min: 0,
                stepSize: 1,
              },
            },
          ],
          yAxes: [
            {
              stacked: true,
              // barThickness: 40,
              ticks: {
                max: 5,
                min: 0,
                stepSize: 1,
              },
            },
          ],
        },
      },
    });
  }

  // /Get All Users information
  private getUsersList() {
    this.loading = true;
    var userEmail = '';
    if (JSON.parse(localStorage.getItem('user')).userData.userRoll == 4)
      userEmail = JSON.parse(localStorage.getItem('user')).userData.userEmail;

    this.commonService
      .getUsersListByPost(
        JSON.parse(localStorage.getItem('user')).userData.towerId,
        userEmail
      )
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.userList = data;
          } else {
            localStorage.setItem('errorMsg', 'Users Not Found');
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get All Users information
  private getNextPosition() {
    this.loading = true;
    this.commonService
      .getNextPosition(this.selectedUserId)
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data && data.length > 0) {
            this.nextPosition = data[0].positionName;
          } else {
            localStorage.setItem(
              'errorMsg',
              'User is already at the highest level'
            );
            this.commonService.showerror();
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // //load whole page data
  // private loadDashboardData(skillType) {

  //   if(skillType === 'fun')
  //     this.getUserFunSkillInfo();
  //   else
  //     this.getUserBehSkillInfo();
  // }

  generateDashboardData(skillType) {
    // this.getNextPosition();
    // this.loadDashboard();

    this.generateSkillDevelopmentChart(skillType);
    this.generateFourBlocksData(skillType);
    this.showDashboardSections = true;
  }

  getPositionName(positionId) {
    for (let i = 0; i < this.positionList.length; i++) {
      if (this.positionList[i].positionId == positionId)
        return this.positionList[i].positionName;
    }
  }

  // /fetch user information data
  private fetchPositions() {
    //var towerId = JSON.parse(localStorage.user).userData.towerId;
    this.commonService
      .getAllPositionInfo(null)
      .pipe(first())
      .subscribe(
        (data) => {
          this.positionList = data;
        },
        (error) => {
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  // Get Skill Details From Skill Master
  // private getSkillDetails() {
  //   this.loading = true;
  //   this.commonService.getSkillDetails().pipe(first()).subscribe(
  //     data => {
  //       this.loading = false;
  //       if (data && data.length > 0) {
  //         this.skillList = data;
  //       } else {
  //         this.loading = false;
  //         localStorage.setItem('errorMsg', "Skills Data Not Found");
  //         this.commonService.showerror();
  //         localStorage.removeItem('errorMsg');
  //       }
  //     },
  //     error => {
  //       this.loading = false;
  //       localStorage.setItem('errorMsg', error.statusText);
  //       this.commonService.showerror();
  //       localStorage.removeItem('errorMsg');
  //     }
  //   )
  // }

  // // Get Behavioral Skill Details From Skill Master
  // private getAllBehSkills() {
  //   this.loading = true;
  //   this.commonService.getAllBehSkills().pipe(first()).subscribe(
  //     data => {
  //       this.loading = false;
  //       if (data && data.length > 0) {
  //         this.behSkillList = data;
  //       } else {
  //         this.loading = false;
  //         localStorage.setItem('errorMsg', "Behavioral Skills Data Not Found");
  //         this.commonService.showerror();
  //         localStorage.removeItem('errorMsg');
  //       }
  //     },
  //     error => {
  //       this.loading = false;
  //       localStorage.setItem('errorMsg', error.statusText);
  //       this.commonService.showerror();
  //       localStorage.removeItem('errorMsg');
  //     }
  //   )
  // }

  //Get user skills data
  // private getUserFunSkillInfo() {
  //   this.userSkillRatingData = [];
  //   if (!this.selectedUserId || this.selectedUserId == "Select User") {
  //     localStorage.setItem('errorMsg', "Please select user first!");
  //     this.commonService.showerror();
  //     localStorage.removeItem('errorMsg');
  //     return;
  //   }
  //   this.loading = true;
  //   let userIds = [Number(this.selectedUserId)];

  //   this.commonService.fetchAllFunSkills(userIds).pipe(first()).subscribe(
  //     data => {
  //       if (data && data.length > 0) {
  //         this.userFunSkillList = data;
  //         this.getUserFunSkillRatingInfo(Number(this.selectedUserId));
  //         console.log("userFunSkillList", this.userFunSkillList)
  //       } else {
  //         this.loading = false;
  //         localStorage.setItem('errorMsg', "User skill not found");
  //         this.commonService.showerror();
  //         localStorage.removeItem('errorMsg');
  //       }
  //     },
  //     error => {
  //       this.loading = false;
  //       localStorage.setItem('errorMsg', error.statusText);
  //       this.commonService.showerror();
  //       localStorage.removeItem('errorMsg');
  //     }
  //   )
  // }

  // //Get user skills data
  // private getUserBehSkillInfo() {
  //   this.userSkillRatingData = [];
  //   if (!this.selectedUserId || this.selectedUserId == "Select User") {
  //     localStorage.setItem('errorMsg', "Please select user first!");
  //     this.commonService.showerror();
  //     localStorage.removeItem('errorMsg');
  //     return;
  //   }
  //   this.loading = true;
  //   let userIds = [Number(this.selectedUserId)];
  //   this.commonService.fetchAllBehSkills(userIds).pipe(first()).subscribe(
  //     data => {
  //       if (data && data.length > 0) {
  //         this.userBehSkillList = data;
  //         this.getUserBehSkillRatingInfo(Number(this.selectedUserId));
  //         console.log("userBehSkillList", this.userBehSkillList)
  //       } else {
  //         this.loading = false;
  //         localStorage.setItem('errorMsg', "User skill not found");
  //         this.commonService.showerror();
  //         localStorage.removeItem('errorMsg');
  //       }
  //     },
  //     error => {
  //       this.loading = false;
  //       localStorage.setItem('errorMsg', error.statusText);
  //       this.commonService.showerror();
  //       localStorage.removeItem('errorMsg');
  //     }
  //   )
  // }

  //Get user skills data
  private getUserFunSkillRatingInfo() {
    this.selectedUserId = this.selectedCombinedId.split('_')[0];
    this.selectedPositionId = this.selectedCombinedId.split('_')[1];
    let selectedUserTowerId = this.selectedCombinedId.split('_')[2];

    if (!this.selectedUserId || this.selectedUserId == 'Select User') {
      localStorage.setItem('errorMsg', 'Please select user first!');
      this.commonService.showerror();
      localStorage.removeItem('errorMsg');
      return;
    }
    this.loading = true;
    let userIds = [Number(this.selectedUserId)];
    var userId: any = Number(this.selectedUserId);

    this.functionalActive = 'active';
    this.behavioralActive = '';
    const towerId = JSON.parse(localStorage.getItem('user')).userData.towerId
      ? JSON.parse(localStorage.getItem('user')).userData.towerId
      : selectedUserTowerId;

    this.commonService
      .getUserFunSkillRatingInfo(userId, undefined, this.selectedPositionId)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            this.userFunSkillRatingList = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].positionId != this.selectedPositionId) continue;

              this.userFunSkillRatingList.push(data[i]);
            }

            // this.filterScoreComputation(true);
            // this.generateDashboardData('fun');
            this.compositePercentAverage = this.getCompositeValue();
            this.showDashboardSections = true;
          } else {
            this.loading = false;
            this.userFunSkillRatingList = [];
            localStorage.setItem('errorMsg', 'User skill rating not found');
            this.commonService.showerror();
            this.showDashboardSections = false;
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          this.userFunSkillRatingList = [];
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );
  }

  private loadDashboard() {
    this.selectedUserId = this.selectedCombinedId.split('_')[0];
    this.selectedPositionId = this.selectedCombinedId.split('_')[1];

    for (var i = 0; i < this.userList.length; i++) {
      if (this.userList[i].userId == this.selectedUserId) {
        this.selectedUserPosition = this.userList[i].positionName;
        this.selectedUserName = this.userList[i].userName;
        this.nextPositionId = this.userList[i].nextPosition;
      }
    }

    this.getUserBehSkillRatingInfo();
  }

  //export resource history data
  private excelDownload() {
    let excelExportData = [];
    let headers = [
      'S.No.',
      'Competency',
      'Self Rating',
      'Manager Rating',
      'Gap',
      'Target',
      'Competency type',
    ];

    let userSkill = [this.userBehSkillRatingList, this.userFunSkillRatingList];
    let sno = 0;

    this.commonService
      .getUserFunSkillRatingInfo(
        this.selectedUserId,
        undefined,
        //JSON.parse(localStorage.getItem('user')).userData.towerId,
        this.selectedPositionId
      )
      .pipe(first())
      .subscribe((data1) => {
        this.commonService
          .getUserBehSkillRatingInfo(
            this.selectedUserId,
            undefined,
            //JSON.parse(localStorage.getItem('user')).userData.towerId,
            this.selectedPositionId
          )
          .pipe(first())
          .subscribe(
            (data2) => {
              debugger;
              let funcRatingData = {};

              let functionalData = [];
              let funSkillCount = 0;
              if (data1 && data1.length > 0) {
                for (let i = 0; i < data1.length; i++) {
                  funSkillCount++;
                  if (
                    data1[i].positionId != this.selectedPositionId ||
                    data1[i].ratedByRole != 5
                  )
                    continue;
                  let obj = {
                    skillId: data1[i].skillId,
                    skillName: data1[i].skillName,
                    selfRatingScore: data1[i].skillScore,
                    managerRatingScore: '',
                    targetScore: data1[i].targetScore,
                    skillType: 'Functional',
                  };
                  functionalData.push(obj);
                  if (data1.length) {
                    // For extract Manager Rating.
                    for (let j = 0; j < data1.length; j++) {
                      if (
                        data1[j].positionId != this.selectedPositionId ||
                        data1[j].ratedByRole != 4
                      )
                        continue;

                      let index = functionalData.findIndex(
                        (item) => item.skillId == data1[j].skillId
                      );
                      if (index != -1) {
                        functionalData[index].managerRatingScore =
                          data1[j].skillScore;
                      }
                    }
                  }
                }
              }
              let behavioralData = [];
              let behSkillCount = 0;
              if (data2 && data2.length > 0) {
                for (let i = 0; i < data2.length; i++) {
                  behSkillCount++;
                  if (
                    data2[i].positionId != this.selectedPositionId ||
                    data2[i].ratedByRole != 5
                  )
                    continue;
                  let obj = {
                    skillId: data2[i].skillId,
                    skillName: data2[i].skillName,
                    selfRatingScore: data2[i].skillScore,
                    managerRatingScore: '',
                    targetScore: data2[i].targetScore,
                    skillType: 'Behavioral',
                  };

                  behavioralData.push(obj);

                  if (data2.length) {
                    // For extract Manager Rating.
                    for (let j = 0; j < data2.length; j++) {
                      if (
                        data2[j].positionId != this.selectedPositionId ||
                        data2[j].ratedByRole != 4
                      )
                        continue;

                      let index = behavioralData.findIndex(
                        (item) => item.skillId == data2[j].skillId
                      );
                      if (index != -1) {
                        behavioralData[index].managerRatingScore =
                          data2[j].skillScore;
                      }
                    }
                  }
                }
              }
              let skillList = [];
              if (functionalData && behavioralData) {
                skillList = [...functionalData, ...behavioralData];
              }
              if (skillList && skillList.length > 0) {
                for (let i = 0; i < skillList.length; i++) {
                  let data = {};

                  data[headers[0]] = ++sno;

                  data[headers[1]] = skillList[i].skillName;
                  data[headers[2]] = skillList[i].selfRatingScore;
                  data[headers[3]] = skillList[i].managerRatingScore;
                  data[headers[4]] =
                    skillList[i].targetScore - skillList[i].managerRatingScore;
                  data[headers[5]] = skillList[i].targetScore;
                  data[headers[6]] = skillList[i].skillType;
                  // data[headers[7]] = skillList[i].skillType;
                  excelExportData.push(data);
                }
                // }

                // return;
                this.excelService.generateExcel(
                  headers,
                  excelExportData,
                  this.selectedUserName
                );

                // this.filterScoreComputation(true);
                // this.generateDashboardData('fun');
                this.compositePercentAverage = this.getCompositeValue();
                this.showDashboardSections = true;
              } else {
                this.loading = false;
                // this.userFunSkillRatingList = [];
                localStorage.setItem('errorMsg', 'User skill rating not found');
                this.commonService.showerror();
                this.showDashboardSections = false;
                localStorage.removeItem('errorMsg');
              }
            },
            (error) => {
              this.loading = false;
              // this.userFunSkillRatingList = [];
              localStorage.setItem('errorMsg', error.statusText);
              this.commonService.showerror();
              localStorage.removeItem('errorMsg');
            }
          );
      });

    // for (let i = 0; i < this.fetchData.length; i++) {
    //   let data = {};
    //   data[headers[0]] = i + 1;
    //   data[headers[1]] = this.fetchData[i].userName;
    //   data[headers[2]] = this.fetchData[i].typeResource;
    //   data[headers[3]] = new Date(this.fetchData[i].joinDate);
    //   data[headers[5]] = new Date(this.fetchData[i].leaveDate);
    //   data[headers[6]] = this.fetchData[i].team;
    //   data[headers[7]] = this.fetchData[i].email;
    //   data[headers[8]] = this.fetchData[i].createdByEmail;
    //   for (let j = 0; j < this.skillData.length; j++) {
    //     let userSkill = this.fetchData[i].userSkill
    //     for (let k = 0; k < userSkill.length; k++) {
    //       if (userSkill[k].skillId == this.skillData[j].skillId)
    //         data[headers[9 + j]] = userSkill[k].skillLevel;
    //     }
    //   }

    //   excelExportData.push(data);
    // }
  }

  //Get user skills data
  private getUserBehSkillRatingInfo() {
    this.selectedUserId = this.selectedCombinedId.split('_')[0];
    this.selectedPositionId = this.selectedCombinedId.split('_')[1];
    let selectedUserTowerId = this.selectedCombinedId.split('_')[2];

    if (!this.selectedUserId || this.selectedUserId == 'Select User') {
      localStorage.setItem('errorMsg', 'Please select user first!');
      this.commonService.showerror();
      localStorage.removeItem('errorMsg');
      return;
    }
    this.loading = true;
    let userIds = [Number(this.selectedUserId)];
    var userId: any = Number(this.selectedUserId);

    this.functionalActive = '';
    this.behavioralActive = 'active';
    const towerId = JSON.parse(localStorage.getItem('user')).userData.towerId
      ? JSON.parse(localStorage.getItem('user')).userData.towerId
      : selectedUserTowerId;
    this.commonService
      .getUserBehSkillRatingInfo(userId, undefined, this.selectedPositionId)
      .pipe(first())
      .subscribe(
        (data) => {
          if (data && data.length > 0) {
            debugger;
            this.userBehSkillRatingList = [];
            for (let i = 0; i < data.length; i++) {
              if (data[i].positionId != this.selectedPositionId) continue;

              this.userBehSkillRatingList.push(data[i]);
            }

            // this.filterScoreComputation(false);
            this.generateDashboardData('beh');
            this.getUserFunSkillRatingInfo();
            this.showDashboardSections = true;
          } else {
            this.loading = false;
            this.userBehSkillRatingList = [];
            localStorage.setItem('errorMsg', 'User skill rating not found');
            this.commonService.showerror();
            this.showDashboardSections = false;
            localStorage.removeItem('errorMsg');
          }
        },
        (error) => {
          this.loading = false;
          this.userBehSkillRatingList = [];
          localStorage.setItem('errorMsg', error.statusText);
          this.commonService.showerror();
          localStorage.removeItem('errorMsg');
        }
      );

    // this.getUserFunSkillRatingInfo();
  }

  private getCompositeValue() {
    var compositeBehSum = 0,
      compositeFunSum = 0;
    var countBeh = 0,
      countFun = 0;

    for (var i = 0; i < this.userBehSkillRatingList.length; i++) {
      if (this.userBehSkillRatingList[i].ratedByRole !== 4) continue;

      var thisSkillsPercentage =
        (this.userBehSkillRatingList[i].skillScore * 100) /
        this.userBehSkillRatingList[i].targetScore;

      compositeBehSum +=
        thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage;
      countBeh++;
    }

    for (var j = 0; j < this.userFunSkillRatingList.length; j++) {
      if (this.userFunSkillRatingList[j].ratedByRole !== 4) continue;

      var thisSkillsPercentage =
        (this.userFunSkillRatingList[j].skillScore * 100) /
        this.userFunSkillRatingList[j].targetScore;

      compositeFunSum +=
        thisSkillsPercentage > 100 ? 100 : thisSkillsPercentage;
      countFun++;
    }
    // return Math.floor( ((compositeBehSum /countBeh)*0.3 + (compositeFunSum / countFun)*0.7));
    return {
      full: Math.floor(
        (compositeBehSum / countBeh) * 0.3 + (compositeFunSum / countFun) * 0.7
      ),
      beh: Math.floor(compositeBehSum / countBeh),
      fun: Math.floor(compositeFunSum / countFun),
    };
  }

  // reset on date selection
  private onDateSelection(date: NgbDateStruct) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && after(date, this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  // frorward to next section
  public gotoNextPage(e, routeURL) {
    this.router.navigate([routeURL]);
  }

  // logout and forward to next section
  private logout() {
    this.commonService.logout();
  }
  /**
   * Check the number is NaN or not
   */
  checkIsNumber(value) {
    if (isNaN(value) || value == null || value == 'null' || value == '') {
      return '';
    } else {
      return value + ' %';
    }
  }
}
